"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createProvider = createProvider;

var _react = _interopRequireWildcard(require("react"));

/**
 * Create a state provider
 */
function createProvider(stateContext, dispatchContext, reducer, initialState) {
  return ({
    children
  }) => {
    const [s, d] = (0, _react.useReducer)(reducer, initialState);

    const state = _react.default.useMemo(() => s, [s]);

    const dispatch = _react.default.useMemo(() => d, [d]);

    return /*#__PURE__*/_react.default.createElement(stateContext.Provider, {
      value: state
    }, /*#__PURE__*/_react.default.createElement(dispatchContext.Provider, {
      value: dispatch
    }, children));
  };
}